module.exports = {
  WHATSAPP: '+542996322863'
};
